"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M6.89941 6.24219L7.99316 0.890625H9.21875L7.57812 8H6.39648L5.04395 2.80957L3.66211 8H2.47559L0.834961 0.890625H2.06055L3.16406 6.23242L4.52148 0.890625H5.55664L6.89941 6.24219Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;